import axios from './axios';
import type { PointOffersResponse } from '../types/pointOffers';

export const getPointOffers = async (): Promise<PointOffersResponse> => {
  const response = await axios.get('/api/shop/point-offers');
  return response.data;
};

export const redeemPointOffer = async (offerId: number) => {
  const response = await axios.post('/api/shop/redeem-point-offer', { 'discountId': offerId });
  return response.data;
};

export default getPointOffers;
